import { render } from "./Register.vue?vue&type=template&id=63ae9146"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Register.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63ae9146"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63ae9146', __exports__)) {
    api.reload('63ae9146', __exports__)
  }
  
  module.hot.accept("./Register.vue?vue&type=template&id=63ae9146", () => {
    api.rerender('63ae9146', render)
  })

}


export default __exports__